<!-- This is the main component of the Angular application -->
<router-outlet />
